<template>
    <div>
        <select :value="value" @change="update($event)">
            <option :value="null" disabled>please select...</option>
            <option v-for="option, idx in field.options" :value="option" :key="idx">{{option}}</option>
        </select>
    </div>
</template>

<script>
    export default {
        name: 'v-select-field',
        props:['value', 'field'],
        methods:{
            update(ev){
                this.$emit('input', ev.target.value)
            }
        }
    }
</script>

<style scoped lang="scss">
</style>
